import {Type} from "@qwoach/class-transformer-wrapper";
import ShareableFilterableItem from "@shared/ShareableFilterableItem.js";
import BaseToolShareSettings from "@shared/GenericTools/BaseToolShareSettings.js";
import BaseToolEmbedSettings from "@shared/GenericTools/BaseToolEmbedSettings.js";
import AdditionalInfoItem from "@shared/Profile/AdditionalInfoItem.js";
import {ToolInstanceStatusEnum} from "@shared/GenericTools/ToolInstanceStatusEnum.js";
import {DEFAULT_TOOL_THANK_YOU_MESSAGE} from "@shared/SharedConstants.js";

export default class BaseToolInstance extends ShareableFilterableItem {
	toolType: string = ""
	ownerId: string = ""
	title: string = ""
	needsSetup: boolean = false
	status: string = ToolInstanceStatusEnum.DRAFT
	config: any = null
	thankYouMessage: string = DEFAULT_TOOL_THANK_YOU_MESSAGE
	submissionProfileStatus: any = null

	@Type(() => BaseToolShareSettings)
	shareSettings: BaseToolShareSettings = null

	@Type(() => BaseToolEmbedSettings)
	embedSettings: BaseToolEmbedSettings = null

	@Type(() => AdditionalInfoItem)
	submissionDetails: AdditionalInfoItem = new AdditionalInfoItem()

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}
}
